<template>
  <v-card class="nospace">
    <v-card-text class="nospace">
      <v-data-table
        id="datatable2"
        hide-actions
        :headers="headers"
        :items="LHR.LHR"
        :disable-initial-sort="true"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.destination }}</td>
          <td>{{ props.item.request }}</td>
          <td>{{ props.item.confirmed }}</td>
          <td>{{ props.item.pending }}</td>
          <td>{{ props.item.cancel }}</td>
          <td>{{ props.item.total }}</td>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
import { LHRDashboardList } from "@/constants/datatable-headers.js";
export default {
  created() {},
  props: {
    LHR: Object,
  },
  data() {
    return {
      headers: LHRDashboardList,
      items: [],
    };
  },
};
</script>
<style lang="scss">
#datatable2 .theme--light.v-datatable thead th.column.sortable .v-icon {
  opacity: 0.3 !important;
  color: white !important;
  margin-left: 10px !important;
}
#datatable2 .theme--light.v-datatable thead th.column.sortable.active .v-icon {
  opacity: 1 !important;
  color: white !important;
  margin-left: 10px !important;
}
.table-header-item1 {
  font-size: 16px !important;
  background: orange !important;
  font-weight: bold;
}
.v-datatable thead th.column.sortable .v-icon {
  opacity: 0.3 !important;
}
</style>
